import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M4.714 4.915a.44.44 0 0 0 .297.11zm0 0-3.6-3.327m3.6 3.327-3.6-3.327m0 0-.006-.006m.006.006-.006-.006m0 0a.3.3 0 0 1-.082-.108.28.28 0 0 1-.002-.23.3.3 0 0 1 .079-.108.4.4 0 0 1 .133-.081.47.47 0 0 1 .335.003q.078.031.13.083m-.593.441.594-.441m0 0 .006.005m-.006-.005.006.005m0 0 2.964 2.74.34.313M1.707 1.147l3.303 3.052m0 0 .34-.314m-.34.314.34-.314m0 0L8.31 1.15a.44.44 0 0 1 .293-.104c.117 0 .221.044.293.11.07.066.102.145.103.219a.3.3 0 0 1-.096.217L5.308 4.915m.042-1.03-.042 1.03m0 0a.44.44 0 0 1-.297.11z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }